<template>
  <svg
    width="31px"
    height="26px"
    viewBox="0 0 31 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Desktop"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="D_guidelines"
        transform="translate(-572.000000, -368.000000)"
      >
        <g
          id="Group"
          transform="translate(440.000000, 369.000000)"
        >
          <g
            id="icon-lots-plans"
            transform="translate(133.000000, 0.000000)"
          >
            <line
              id="Stroke-1"
              x1="16.4794909"
              y1="23.4976"
              x2="12.3485818"
              y2="23.4976"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Stroke-2"
              d="M21.4674909,9.03345455 L5.43621818,8.96145455 C5.43621818,8.96145455 8.2144,19.4363636 13.7729455,19.4363636 C19.3307636,19.4363636 22.7504,5.61309091 22.7504,5.61309091"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Stroke-3"
              d="M21.2890909,2.83490909 C21.2890909,4.15229091 22.3587636,5.22181818 23.6763636,5.22181818 C24.9939636,5.22181818 26.0636364,4.15229091 26.0636364,2.83490909 C26.0636364,1.51752727 24.9939636,0.448 23.6763636,0.448 C22.3587636,0.448 21.2890909,1.51752727 21.2890909,2.83490909 Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <line
              id="Stroke-4"
              x1="28.3797818"
              y1="4.25949091"
              x2="26.0990545"
              y2="3.33367273"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <line
              id="Stroke-5"
              x1="13.7727273"
              y1="19.4368"
              x2="13.7727273"
              y2="23.1422545"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <polyline
              id="Stroke-6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="0.448 4.11723636 5.43636364 8.96232727 3.86836364 3.7616"
            />
            <path
              id="Fill-7"
              d="M23.0780364,2.83665455 C23.0780364,3.20683636 23.3769455,3.50574545 23.7471273,3.50574545 C24.1144,3.50574545 24.4140364,3.20683636 24.4140364,2.83665455 C24.4140364,2.46647273 24.1144,2.16901818 23.7471273,2.16901818 C23.3769455,2.16901818 23.0780364,2.46647273 23.0780364,2.83665455"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'IconLotsPlans'
};
</script>

<style lang="scss" scoped>
  svg{
    stroke: currentColor;
  }
</style>
